import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.to-string.js";
import { reportError } from '@/utils';
/**
 * 从 getCampaignShow 返回的 moduleResps 中提取首屏头图 URL
 * 复用 index.ts 既有优先级逻辑：
 * 1. 查找首个 moduleType === 1 的模块，取其 moduleContent
 * 2. 若存在 moduleType === 8（Tab 组件）且 Tab 索引 > 图片索引，
 *    解析 moduleExtra 中的 tabButtons，取首个含 headImg 的 tab
 */

export function getHeroImgUrl(moduleResps) {
  var _a;

  try {
    if (!moduleResps || !moduleResps.length) {
      return null;
    }

    var firstImgIndex = moduleResps.findIndex(function (el) {
      return (el === null || el === void 0 ? void 0 : el.moduleType) === 1;
    });

    if (firstImgIndex === -1) {
      return null;
    }

    var heroImgUrl = ((_a = moduleResps[firstImgIndex]) === null || _a === void 0 ? void 0 : _a.moduleContent) || ''; // 若存在 Tab 组件且索引在图片之后，取首个含 headImg 的 tab

    var tabModuleIndex = moduleResps.findIndex(function (el) {
      return (el === null || el === void 0 ? void 0 : el.moduleType) === 8;
    });

    if (tabModuleIndex > firstImgIndex) {
      var tabModule = moduleResps[tabModuleIndex];
      var tabExtra = {};

      try {
        tabExtra = JSON.parse((tabModule === null || tabModule === void 0 ? void 0 : tabModule.moduleExtra) || '{}');
      } catch (_b) {
        tabExtra = {};
      }

      var tabButtons = (tabExtra || {}).tabButtons;
      var tabWithHeadImg = tabButtons === null || tabButtons === void 0 ? void 0 : tabButtons.find(function (el) {
        return el === null || el === void 0 ? void 0 : el.headImg;
      });

      if (tabWithHeadImg === null || tabWithHeadImg === void 0 ? void 0 : tabWithHeadImg.headImg) {
        heroImgUrl = tabWithHeadImg.headImg;
      }
    }

    return heroImgUrl || null;
  } catch (e) {
    reportError(e);
    return null;
  }
}
/**
 * 注入 <link rel="preload" as="image" fetchpriority="high">
 * 使头图下载与模块 chunk 下载并行
 */

export function preloadHeroImage(moduleResps) {
  try {
    var heroImgUrl = getHeroImgUrl(moduleResps);

    if (!heroImgUrl) {
      return;
    }

    var optimizedUrl = optimizeHeroImgUrl(heroImgUrl); // 已存在同 href 的 preload link 时不重复注入

    var existingLinks = document.querySelectorAll('link[rel="preload"][as="image"]');

    for (var i = 0; i < existingLinks.length; i++) {
      if (existingLinks[i].getAttribute('href') === optimizedUrl) {
        return;
      }
    }

    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.setAttribute('fetchpriority', 'high');
    link.href = optimizedUrl;
    document.head.appendChild(link);
  } catch (e) {
    reportError(e);
  }
}
/**
 * 仅当 URL 命中 jojopublic 域且已携带 props 查询参数时，
 * 将宽度参数改写为 750（750px 设计稿基准 = 375 CSS px 的 2x 屏实际需要）
 */

export function optimizeHeroImgUrl(url) {
  try {
    if (!url || typeof url !== 'string') {
      return url;
    } // 处理协议相对 URL（//jojopublic.xxx）


    var urlForParse = url.startsWith('//') ? "https:".concat(url) : url;
    var parsed = new URL(urlForParse);

    if (!parsed.hostname.includes('jojopublic')) {
      return url;
    }

    if (!parsed.searchParams.has('props')) {
      return url;
    }

    var props = parsed.searchParams.get('props') || ''; // 匹配常见宽度参数：w_500 / w:500 / w=500 等

    var widthRegex = /w[_:=]\d+/i;
    var newProps = void 0;

    if (widthRegex.test(props)) {
      newProps = props.replace(widthRegex, 'w_750');
    } else {
      newProps = props ? "".concat(props, ",w_750") : 'w_750';
    }

    parsed.searchParams.set('props', newProps);
    var result = parsed.toString(); // 还原协议相对 URL

    if (url.startsWith('//')) {
      result = result.replace(/^https?:/, '');
    }

    return result;
  } catch (_a) {
    return url;
  }
}